'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useEffect } from 'react';
import { useZoomControlsContext } from './zoom-controls.context.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { useId } from '../../hooks/use-id.js';
import { RenderComp } from '../core/render-comp.component.js';
import { VisuallyHidden } from '../visually-hidden/visually-hidden.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(e);
        for(o = 0; o < c.length; o++)t = c[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, c = Object.keys(e);
    for(o = 0; o < c.length; o++)t = c[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
const ZoomControlsValue = renderWithRef('ZoomControlsValue', null, (n, l)=>{
    useDeprecatedProps('ZoomControlsValue', n, [
        {
            propName: 'visuallyHiddenLabel',
            instructions: 'Use `accessibleText` instead'
        }
    ]);
    let { visuallyHiddenLabel: a, accessibleText: u, children: b } = n, f = _object_without_properties(n, [
        "visuallyHiddenLabel",
        "accessibleText",
        "children"
    ]), { setId: m } = useZoomControlsContext(), y = useId(f.id);
    return useEffect(()=>{
        m(y);
    }, [
        y,
        m
    ]), jsxs(RenderComp, {
        root: "span",
        forwardedRef: l,
        classNames: [
            'swan-zoom-controls-value'
        ],
        props: _object_spread_props(_object_spread({}, f), {
            id: y,
            'aria-live': 'polite',
            'aria-atomic': 'true'
        }),
        children: [
            jsx(VisuallyHidden, {
                children: null != u ? u : a
            }),
            b
        ]
    });
});

export { ZoomControlsValue };
